<app-page-title [heading]="heading" [subheading]="subheading" [icon]="icon">    
</app-page-title>
<div class="row" *ngIf="!!embedConfig">
    <div class="col-md-12">
        <powerbi-report [embedConfig]="embedConfig" cssClassName="power-bi-report-container">
        </powerbi-report>          
    </div>
</div>